const HRA_Agreement = ({
    GetSpecificUser,
    parsedFormDataAgreement,
}) => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = dd + "/" + mm + "/" + yyyy;
    return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
  <html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" lang="en">
      <head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <title>e7fd0c23-15a9-4b95-a0c6-0ff87efb01f2</title>
          <meta name="author" content="Ganapathy Srinivasan" />
          <style type="text/css">
              * {
                  margin: 0;
                  padding: 0;
                  text-indent: 0;
              }
              .s1 {
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  text-decoration: underline;
                  font-size: 10pt;
              }
              .p,
              p {
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
                  margin: 0pt;
              }
              h1 {
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  text-decoration: none;
                  font-size: 10pt;
              }
              .s2 {
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  text-decoration: none;
                  font-size: 10pt;
              }
              .s3 {
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              .s4 {
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 6.5pt;
                  vertical-align: 3pt;
              }
              li {
                  display: block;
              }
              #l1 {
                  padding-left: 0pt;
                  counter-reset: c1 1;
              }
              #l1 > li > *:first-child:before {
                  counter-increment: c1;
                  content: counter(c1, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  text-decoration: none;
                  font-size: 9pt;
              }
              #l1 > li:first-child > *:first-child:before {
                  counter-increment: c1 0;
              }
              #l2 {
                  padding-left: 0pt;
                  counter-reset: c2 1;
              }
              #l2 > li > *:first-child:before {
                  counter-increment: c2;
                  content: counter(c1, decimal) "." counter(c2, decimal) " ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l2 > li:first-child > *:first-child:before {
                  counter-increment: c2 0;
              }
              #l3 {
                  padding-left: 0pt;
                  counter-reset: d1 1;
              }
              #l3 > li > *:first-child:before {
                  counter-increment: d1;
                  content: counter(d1, lower-latin) ") ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l3 > li:first-child > *:first-child:before {
                  counter-increment: d1 0;
              }
              #l4 {
                  padding-left: 0pt;
                  counter-reset: d2 1;
              }
              #l4 > li > *:first-child:before {
                  counter-increment: d2;
                  content: counter(d2, lower-roman) ") ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 11pt;
              }
              #l4 > li:first-child > *:first-child:before {
                  counter-increment: d2 0;
              }
              #l5 {
                  padding-left: 0pt;
                  counter-reset: d2 1;
              }
              #l5 > li > *:first-child:before {
                  counter-increment: d2;
                  content: counter(d2, lower-roman) ") ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 11pt;
              }
              #l5 > li:first-child > *:first-child:before {
                  counter-increment: d2 0;
              }
              #l6 {
                  padding-left: 0pt;
                  counter-reset: d2 1;
              }
              #l6 > li > *:first-child:before {
                  counter-increment: d2;
                  content: counter(d2, lower-roman) ") ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 11pt;
              }
              #l6 > li:first-child > *:first-child:before {
                  counter-increment: d2 0;
              }
              #l7 {
                  padding-left: 0pt;
                  counter-reset: d2 1;
              }
              #l7 > li > *:first-child:before {
                  counter-increment: d2;
                  content: counter(d2, lower-roman) ") ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 11pt;
              }
              #l7 > li:first-child > *:first-child:before {
                  counter-increment: d2 0;
              }
              #l8 {
                  padding-left: 0pt;
                  counter-reset: e1 4;
              }
              #l8 > li > *:first-child:before {
                  counter-increment: e1;
                  content: counter(e1, decimal) " ";
                  color: black;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
              }
              #l8 > li:first-child > *:first-child:before {
                  counter-increment: e1 0;
              }
              #l9 {
                  padding-left: 0pt;
                  counter-reset: e2 1;
              }
              #l9 > li > *:first-child:before {
                  counter-increment: e2;
                  content: counter(e1, decimal) "." counter(e2, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l9 > li:first-child > *:first-child:before {
                  counter-increment: e2 0;
              }
              #l10 {
                  padding-left: 0pt;
                  counter-reset: f1 6;
              }
              #l10 > li > *:first-child:before {
                  counter-increment: f1;
                  content: counter(f1, decimal) " ";
                  color: black;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
              }
              #l10 > li:first-child > *:first-child:before {
                  counter-increment: f1 0;
              }
              #l11 {
                  padding-left: 0pt;
                  counter-reset: f2 1;
              }
              #l11 > li > *:first-child:before {
                  counter-increment: f2;
                  content: counter(f1, decimal) "." counter(f2, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l11 > li:first-child > *:first-child:before {
                  counter-increment: f2 0;
              }
              #l12 {
                  padding-left: 0pt;
                  counter-reset: g1 7;
              }
              #l12 > li > *:first-child:before {
                  counter-increment: g1;
                  content: counter(g1, decimal) " ";
                  color: black;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
              }
              #l12 > li:first-child > *:first-child:before {
                  counter-increment: g1 0;
              }
              #l13 {
                  padding-left: 0pt;
                  counter-reset: g2 1;
              }
              #l13 > li > *:first-child:before {
                  counter-increment: g2;
                  content: counter(g1, decimal) "." counter(g2, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l13 > li:first-child > *:first-child:before {
                  counter-increment: g2 0;
              }
              #l14 {
                  padding-left: 0pt;
                  counter-reset: h1 8;
              }
              #l14 > li > *:first-child:before {
                  counter-increment: h1;
                  content: counter(h1, decimal) " ";
                  color: black;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
              }
              #l14 > li:first-child > *:first-child:before {
                  counter-increment: h1 0;
              }
              #l15 {
                  padding-left: 0pt;
                  counter-reset: h2 1;
              }
              #l15 > li > *:first-child:before {
                  counter-increment: h2;
                  content: counter(h1, decimal) "." counter(h2, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l15 > li:first-child > *:first-child:before {
                  counter-increment: h2 0;
              }
              #l16 {
                  padding-left: 0pt;
                  counter-reset: i1 9;
              }
              #l16 > li > *:first-child:before {
                  counter-increment: i1;
                  content: counter(i1, decimal) " ";
                  color: black;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
              }
              #l16 > li:first-child > *:first-child:before {
                  counter-increment: i1 0;
              }
              #l17 {
                  padding-left: 0pt;
                  counter-reset: i2 1;
              }
              #l17 > li > *:first-child:before {
                  counter-increment: i2;
                  content: counter(i1, decimal) "." counter(i2, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l17 > li:first-child > *:first-child:before {
                  counter-increment: i2 0;
              }
              #l18 {
                  padding-left: 0pt;
                  counter-reset: j1 10;
              }
              #l18 > li > *:first-child:before {
                  counter-increment: j1;
                  content: counter(j1, decimal) " ";
                  color: black;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
              }
              #l18 > li:first-child > *:first-child:before {
                  counter-increment: j1 0;
              }
              #l19 {
                  padding-left: 0pt;
                  counter-reset: j2 1;
              }
              #l19 > li > *:first-child:before {
                  counter-increment: j2;
                  content: counter(j1, decimal) "." counter(j2, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l19 > li:first-child > *:first-child:before {
                  counter-increment: j2 0;
              }
              #l20 {
                  padding-left: 0pt;
                  counter-reset: j3 1;
              }
              #l20 > li > *:first-child:before {
                  counter-increment: j3;
                  content: counter(j1, decimal) "." counter(j2, decimal) "." counter(j3, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l20 > li:first-child > *:first-child:before {
                  counter-increment: j3 0;
              }
              #l21 {
                  padding-left: 0pt;
                  counter-reset: k1 12;
              }
              #l21 > li > *:first-child:before {
                  counter-increment: k1;
                  content: counter(k1, decimal) " ";
                  color: black;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
              }
              #l21 > li:first-child > *:first-child:before {
                  counter-increment: k1 0;
              }
              #l22 {
                  padding-left: 0pt;
                  counter-reset: k2 1;
              }
              #l22 > li > *:first-child:before {
                  counter-increment: k2;
                  content: counter(k1, decimal) "." counter(k2, decimal) ". ";
                  color: black;
                  font-family: "Public Sans,sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
              }
              #l22 > li:first-child > *:first-child:before {
                  counter-increment: k2 0;
              }
              table,
              tbody {
                  vertical-align: top;
                  overflow: visible;
              }
          </style>
      </head>
      <body style="width:800px;padding:10px">
      <p style="padding-left: 5pt; text-indent: 0pt; text-align: left;">
            <span>
                <table border="0" cellspacing="0" cellpadding="0">
                    <tr>
                        <td>
                            <img
                                width="131"
                                height="128"
                                src="data:image/jpg;base64,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"
                            />
                        </td>
                    </tr>
                </table>
            </span>
        </p>
          <p style="padding-top: 2pt; text-indent: 0pt; text-align: left;"><br /></p>
          <p class="s1" style="padding-left: 189pt; text-indent: 0pt; text-align: left;">Audit Agreement with Food Establishments</p>
          <p style="padding-top: 8pt; padding-left: 235pt; text-indent: -91pt; line-height: 177%; text-align: left;">This audit agreement is entered on <b>${new Date(GetSpecificUser && GetSpecificUser.createdAt).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })}</b>at Chennai By and Between</p>
          <table style="border-collapse: collapse; margin-left: 19.114pt;" cellspacing="0">
              <tr style="height: 93pt;">
                  <td
                      style="
                          width: 246pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; line-height: 11pt; text-align: left;">Caussa Tec Solutions Private Limited,</p>
                      <p class="s3" style="padding-left: 5pt; text-indent: 0pt; line-height: 11pt; text-align: left;">No 255/1B, Brivas Building, 200 Feet Radial Road<br/>Near Lake, Chromepet,<br/>Chennai - 6000044</p>
                  </td>
                  <td
                      style="
                          width: 241pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">FBO,</p>
                      <p style="padding-left: 5pt; text-indent: 0pt; text-align: left;"><b>${GetSpecificUser && GetSpecificUser.companyName}</b><br/>${GetSpecificUser && GetSpecificUser.address} <br/> ${GetSpecificUser && GetSpecificUser.state} <br/> ${GetSpecificUser && GetSpecificUser.country}</p>
                  </td>
              </tr>
          </table>
          <p style="padding-top: 11pt; padding-left: 23pt; text-indent: 0pt; text-align: justify;">
              This Audit Agreement (the Agreement) constitutes the entire agreement between the parties which shall supersede and invalidate all prior representations relating to the subject matter hereof. No amendment and/or variation to the
              agreement shall be valid unless duly signed by both parties.
          </p>
          <p style="padding-top: 11pt; padding-left: 23pt; text-indent: 0pt; text-align: justify;">
              No Work will be performed until one original or digital copy of this agreement, duly signed and dated by the FE, has been returned to CAUSSA.
          </p>
          <p style="text-indent: 0pt; text-align: left;"><br /></p>
          <p style="padding-left: 23pt; text-indent: 0pt; text-align: justify;">No certificate will be issued until the original document has been physically returned to CAUSSA and all Fees have been paid.</p>
          <p style="text-indent: 0pt; text-align: left;"><br /></p>
          <ol id="l1">
              <li data-list-text="1.">
                  <h1 style="padding-left: 34pt; text-indent: -7pt; line-height: 11pt; text-align: justify;">Terms and Conditions – General</h1>
                  <ol id="l2">
                      <li data-list-text="1.1">
                          <p style="padding-left: 48pt; text-indent: -21pt; text-align: justify;">
                              CAUSSA’s performance of the Work requires CAUSSA to be granted access and the right to inspect all relevant physical areas and facilities and provision of all relevant documents and information. To this purpose,
                              FE shall in a timely manner make all necessary decisions and provide CAUSSA with all reasonably necessary access to FE’s work areas and facilities and provide CAUSSA with any and all relevant and correct and
                              complete documentation and information required for the Work. Unless it is explicitly agreed as part of the Work that CAUSSA shall identify discrepancies, errors, inconsistencies or omissions in the information
                              provided by FE, the FE is responsible for all aspects of the information it provides and CAUSSA is entitled to rely on the accuracy and completeness of such information in the performance of the Work.
                          </p>
                      </li>
                      <li data-list-text="1.2">
                          <p style="padding-left: 48pt; text-indent: -21pt; text-align: left;">
                              The certificate provided by FSSAI is only with respect to hygiene conditions on the day of Audit. The FE shall not use this certificate for product standard claim or any misleading claims like the claims related
                              to non-hygienic aspects.
                          </p>
                      </li>
                      <li data-list-text="1.3">
                          <p style="padding-left: 48pt; text-indent: -21pt; text-align: left;">
                              The Scope of Certificate is as defined in chapters 1&amp;2 of the Guidance Document (3<span class="s4">rd</span> Edition September 2019) issued by FSSAI
                          </p>
                          <p style="text-indent: 0pt; text-align: left;"><br /></p>
                      </li>
                  </ol>
              </li>
              <li data-list-text="2.">
                  <h1 style="padding-left: 37pt; text-indent: -10pt; line-height: 11pt; text-align: justify;">Work</h1>
                  <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                      2.1. FE may cancel or reschedule execution of audits as communicated in the time of schedule planning, upon prior written notice to CAUSSA (Notice of Postponement). CAUSSA shall if the Notice of Postponement is received
                      later than 14 (fourteen) days prior to the agreed date of audit be entitled to 25% (twenty-five percent) of the agreed Fee, and if the Notice of Postponement is received later than 7 (seven) days prior to the agreed date
                      of audit be entitled to 50% (fifty-percent) of the agreed Fee as compensation for the postponement.
                  </p>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="3.">
                  <h1 style="padding-left: 37pt; text-indent: -10pt; line-height: 11pt; text-align: justify;">Audit Requirements</h1>
                  <ol id="l3">
                      <li data-list-text="a)">
                          <p style="padding-left: 62pt; text-indent: -17pt; line-height: 17pt; text-align: left;">The Food Establishment (FE) is expected to always fulfil –</p>
                          <ol id="l4">
                              <li data-list-text="i)"><p style="padding-left: 116pt; text-indent: -17pt; line-height: 11pt; text-align: left;">audit requirements as specified in “Hygiene Rating Scheme”,</p></li>
                              <li data-list-text="ii)">
                                  <p style="padding-left: 116pt; text-indent: -17pt; line-height: 12pt; text-align: left;">audit scheme and process requirements as specified in “Hygiene Rating Scheme – Audit Process”.</p>
                                  <p style="padding-top: 11pt; padding-left: 63pt; text-indent: 0pt; text-align: left;">
                                      The above are defined by the Quality Council of India (QCI), and the changes in them will be communicated by CAUSSA, time to time;
                                  </p>
                              </li>
                          </ol>
                      </li>
                      <li data-list-text="b)">
                          <p style="padding-left: 62pt; text-indent: -17pt; line-height: 17pt; text-align: left;">The Food Establishment (FE) is expected to make all necessary arrangements for the conduct of audits, including:</p>
                          <ol id="l5">
                              <li data-list-text="i)"><p style="padding-left: 116pt; text-indent: -17pt; line-height: 11pt; text-align: left;">provision for examining documentation</p></li>
                              <li data-list-text="ii)">
                                  <p style="padding-left: 116pt; text-indent: -17pt; line-height: 12pt; text-align: left;">access to all processes and areas, records, and personnel</p>
                                  <p style="padding-top: 1pt; text-indent: 0pt; text-align: left;"><br /></p>
                                  <p style="padding-left: 63pt; text-indent: 0pt; line-height: 11pt; text-align: left;">For the purposes of initial Audit, surveillance, renewal Audit and resolution of complaints.</p>
                              </li>
                          </ol>
                      </li>
                      <li data-list-text="c)">
                          <p style="padding-top: 2pt; padding-left: 63pt; text-indent: -18pt; line-height: 81%; text-align: left;">
                              The Food Establishment (FE) is expected to make provisions, where applicable, to accommodate the presence of observers (e.g. QCI assessors or trainee Auditors);
                          </p>
                      </li>
                      <li data-list-text="d)">
                          <p style="padding-left: 62pt; text-indent: -17pt; line-height: 17pt; text-align: left;">The Food Establishment (FE) is expected to implement changes in its systems</p>
                          <ol id="l6">
                              <li data-list-text="i)">
                                  <p style="padding-left: 116pt; text-indent: -17pt; line-height: 11pt; text-align: left;">When the Audit scheme introduces new or revised requirements both in Audit criteria and Audit process</p>
                                  <p style="padding-left: 117pt; text-indent: 0pt; line-height: 11pt; text-align: left;">requirements</p>
                              </li>
                          </ol>
                      </li>
                      <li data-list-text="e)">
                          <p style="padding-top: 2pt; padding-left: 63pt; text-indent: -18pt; line-height: 81%; text-align: left;">
                              The Food Establishment (FE) is expected to inform the FSSAI, and during the contract period to CAUSSA, without delay in the event of any of the following:
                          </p>
                          <ol id="l7">
                              <li data-list-text="i)"><p style="padding-left: 116pt; text-indent: -17pt; line-height: 12pt; text-align: left;">Change and/or modifications of premises</p></li>
                              <li data-list-text="ii)"><p style="padding-left: 116pt; text-indent: -17pt; line-height: 12pt; text-align: left;">Major changes in the internal control measures</p></li>
                              <li data-list-text="iii)">
                                  <p style="padding-left: 117pt; text-indent: -18pt; text-align: left;">Major changes in the system which could have bearing on implementing Good Hygienic Practices as specified in the Audit criteria.</p>
                              </li>
                          </ol>
                      </li>
                  </ol>
                  <p style="padding-left: 22pt; text-indent: 0pt; text-align: left;">CAUSSA has also identified the aspects that would be considered as misleading and unauthorized as relevant to the Hygiene Rating Scheme.</p>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="4.">
                  <h1 style="padding-left: 37pt; text-indent: -10pt; line-height: 11pt; text-align: justify;">Issuance and Maintenance of the Certificate of Conformity</h1>
                  <ol id="l8">
                      <ol id="l9">
                          <li data-list-text="4.1.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  Upon completion of the audit process, CAUSSA shall upload relevant documents, evidences &amp; reports to the centralized repository maintained on behalf of FSSAI, subject to payment being made by FE in
                                  accordance with this Agreement.
                              </p>
                              <p style="padding-left: 27pt; text-indent: 0pt; line-height: 11pt; text-align: justify;">CAUSSA shall provide the link to the FEs, on which FE shall view the status of the Audit.</p>
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  After, evaluation of the audit, FSSAI will upload “Verified Hygiene Rating Certificate” in the name of the FE. The FE (FE) can download the certificate
                              </p>
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  FE shall have the right to use the valid certificate and certification marks in standard size and design as provided by FSSAI for the purposes for which such certificates are generally intended and used,
                                  including on letters, documents and other promotional material.
                              </p>
                          </li>
                          <li data-list-text="4.2.">
                              <p style="padding-left: 44pt; text-indent: -17pt; text-align: justify;">Misleading and Unauthorized aspects:</p>
                              <p style="padding-left: 23pt; text-indent: 0pt; text-align: justify;">
                                  In case of incorrect reference to certification status or misleading use of certification documents or marks or other breach of the applicable requirements for the maintenance and use of the certificates and
                                  the certification mark as instructed by FSSAI, FSSAI may decide corrective actions as well as suspension or withdrawal of certificate and publication of the transgression. FE shall immediately implement such
                                  corrective actions. Unauthorized personnel shall not be engaged by the FE for any audit-related activities.
                              </p>
                          </li>
                          <li data-list-text="4.3.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  FE must undergo all scheduled audits and visits. FE must report all changes in its operations and management systems (hereunder changes in organization, ownership, new products and services, location, number
                                  of employees, major incidents or stakeholder disputes, serious incidents or breach of regulation necessitating the involvement of relevant competent authority etc.), which may reasonably affect the
                                  certificate of conformity, to CAUSSA without undue delay and preferably before execution of such change. Based on this, and provided that the FE wants to maintain the certificate of conformity, CAUSSA may
                                  carry out additional audits.
                              </p>
                          </li>
                          <li data-list-text="4.4.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  FE must at all times ensure that the requirements of Hygiene Rating Scheme(s) are complied with and take necessary action in accordance with the reported non-conformities, observations, improvement
                                  opportunities and noteworthy efforts, as guided by CAUSSA.
                              </p>
                          </li>
                          <li data-list-text="4.5.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  FSSAI may at its discretion suspend or withdraw any certificate of issued with immediate effect, if the requirements stipulated in 3.1-3.4 above are no longer satisfied or if payment by the FE is not made in
                                  accordance with this Agreement.
                              </p>
                          </li>
                          <li data-list-text="4.6.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">Upon withdrawal of the certificate, the FE discontinues its use of all advertising matter that contains a reference to certification.</p>
                          </li>
                      </ol>
                  </ol>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="5.">
                  <h1 style="padding-left: 37pt; text-indent: -10pt; line-height: 11pt; text-align: justify;">Complaints &amp; Appeals</h1>
                  <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                      The FE may complain about auditor’s auditing process if not in line with the requirements as specified by FSSAI or the Food Safety Act to CAUSSA’s Top Management through email, for which necessary actions will be taken
                      and the status of the same shall be communicated to the FE.
                  </p>
                  <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                      The FE may appeal against CAUSSA’s decision not to issue or to suspend or withdraw the certificate in accordance with the requirements set out in the Hygiene Rating Scheme directly to FSSAI and the final decision on
                      Appeals will be made by FSSAI. Investigation and decision on appeals shall not result in any discriminatory actions.
                  </p>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="6.">
                  <h1 style="padding-left: 37pt; text-indent: -10pt; text-align: justify;">Intellectual Property</h1>
                  <p style="padding-top: 1pt; text-indent: 0pt; text-align: left;"><br /></p>
                  <ol id="l10">
                      <ol id="l11">
                          <li data-list-text="6.1.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  For the purpose of this Agreement, each party shall remain the sole owner of any of its intellectual property and rights thereto existing prior to the date of this Agreement, including, but not limited to,
                                  CAUSSA or FSSAI templates for certificates, reports and checklists. CAUSSA shall be entitled to use, for the purpose of its own audit activities, the know- how that CAUSSA acquires in the course of the
                                  performance of the Work.
                              </p>
                          </li>
                          <li data-list-text="6.2.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  CAUSSA shall hold all intellectual property rights to the reports given to FE under this Agreement (the Deliverables), including the copyright. FE shall use the valid certificates in accordance with the
                                  Hygiene Rating Scheme requirements and use the reports for its own internal purposes. The reports shall not be disclosed to third parties without CAUSSA’s prior written consent.
                              </p>
                          </li>
                          <li data-list-text="6.3.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  The FE shall only make available the Deliverables in their entirety to third parties without altering the content, context or original language of the Deliverable.
                              </p>
                          </li>
                      </ol>
                  </ol>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="7.">
                  <h1 style="padding-left: 37pt; text-indent: -10pt; line-height: 11pt; text-align: justify;">Confidentiality</h1>
                  <ol id="l12">
                      <ol id="l13">
                          <li data-list-text="7.1.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  Each party agrees to keep any information it receives from the other party in course of the Agreement which by denotation or reasonable circumstances is considered confidential to the disclosing party, in
                                  confidentiality. The recipient party shall treat such received information with reasonable care and diligence, not disseminating or disclosing it to third parties without the other party’s prior written
                                  consent, provided however that CAUSSA may share such information with its officers, employees, and those of FSSAI who are subject to confidentiality obligations reflecting the principles herein.
                              </p>
                          </li>
                          <li data-list-text="7.2.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  The obligations hereinabove shall not apply to and each party shall be free to disclose, any information which: (i) was known to the recipient prior to the information being disclosed by the other party, or
                                  becomes known to the recipient through a third party without any confidentiality obligation; (ii) is or becomes generally available in the public domain through no act or failure to act on the part of the
                                  recipient; and (iii) is required to be disclosed by any relevant accreditation body, any competent court, governmental agency, or other relevant public authority in accordance with applicable law, court order
                                  or other public regulation.
                              </p>
                          </li>
                          <li data-list-text="7.3.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  Notwithstanding the above, CAUSSA shall have the right to (i) use for statistical and analytical purposes any information generated in the course of the Work, provided that such is kept internal or published
                                  only in aggregated anonymous forms; (ii) make reference to the FE in CAUSSA’s marketing; and (iii) extend the audit team with third parties as set out in this Agreement.
                              </p>
                          </li>
                          <li data-list-text="7.4.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  The obligations in this section shall survive the completion of the Work or termination of this Audit Agreement and remain in effect for as long as the relevant information is confidential.
                              </p>
                          </li>
                      </ol>
                  </ol>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="8.">
                  <h1 style="padding-left: 37pt; text-indent: -10pt; line-height: 11pt; text-align: justify;">Termination</h1>
                  <ol id="l14">
                      <ol id="l15">
                          <li data-list-text="8.1.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">This Agreement shall remain in full force and effect until terminated by any one of the parties as set out in this Agreement.</p>
                          </li>
                          <li data-list-text="8.2.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  Each party may terminate this Agreement by written notice to the other party under the following circumstances: (i) if the other party commits a material breach of this Agreement and fail to rectify such
                                  within 10 working days after the other party’s written notice; (ii) if the other party becomes insolvent, unable to pay its debts as they fall due, or subject to bankruptcy proceedings, receivership,
                                  dissolution, liquidation, wind-up or otherwise discontinue business; (iii) for convenience after serving the other party a written notice 60 days prior to termination.
                              </p>
                          </li>
                      </ol>
                  </ol>
                  <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                      8.3 If the FE terminates this Agreement pursuant to Article 7.2(iii) or CAUSSA terminates pursuant to Article 7.2(i) or 7.2(ii), CAUSSA shall be entitled to full remuneration for the Work carried out prior to the
                      termination and for all documented incurred unrecoverable costs. CAUSSA shall be entitled to the payment of the 25% of the overall contract value, or the minor Value CAUSSA wants to apply, as a penalty (excluded the
                      possibility to the reimbursement of a higher damage) related to Art 7.1(i) and 7.2(ii) and as a wage for the termination indicated in Art. 7.2 (iii).
                  </p>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="9.">
                  <h1 style="padding-left: 37pt; text-indent: -10pt; line-height: 11pt; text-align: justify;">Health, Safety and Environment (HSE)</h1>
                  <ol id="l16">
                      <ol id="l17">
                          <li data-list-text="9.1.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  Both parties shall employ reasonable standards for promoting health, safety and environmental sound working environments for their respective personnel and work sites.
                              </p>
                          </li>
                          <li data-list-text="9.2.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  The FE shall inform CAUSSA without undue delay of any (i) actual or potential HSE risk which FE is aware of and which is reasonably relevant to the performance of the Work, and (ii) any of FE’s implemented or
                                  planned measures against such risks that FE require CAUSSA’s personnel to adhere to.
                              </p>
                          </li>
                          <li data-list-text="9.3.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  Whenever CAUSSA’s performance of the Works involves visits or work on FE’s controlled facility or site, the FE is responsible for the adequacy, stability, safety and legal compliance of the working
                                  environment, including reasonable measures to mitigate or control relevant risks. Whenever CAUSSA’s personnel are present on FE’s facilities or sites, CAUSSA’s personnel will adhere to FE’s HSE instructions
                                  provided according to this article. CAUSSA and/or its personnel, may refuse to carry out any activity, or visit any area or site, if CAUSSA or its personnel in their sole discretion consider that relevant
                                  risks are unacceptable or not adequately addressed, contained or otherwise mitigated. Any such
                              </p>
                          </li>
                      </ol>
                  </ol>
                  <p style="padding-top: 1pt; text-indent: 0pt; text-align: left;"><br /></p>
                  <p style="padding-left: 27pt; text-indent: 0pt; text-align: left;">decision shall suspend both parties’ obligations without any liability or penalty until the parties have agreed on how to proceed.</p>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="10.">
                  <h1 style="padding-left: 38pt; text-indent: -15pt; line-height: 11pt; text-align: justify;">Indemnification and Liabilities</h1>
                  <ol id="l18">
                      <ol id="l19">
                          <li data-list-text="10.1.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  CAUSSA and FSSAI, as well as its and their respective employees, representatives, directors and subcontractors shall not in any way be held liable for any of FE’s and/or any of its subsidiaries, parent
                                  companies or affiliates, or its and their respective employees, representatives, directors and contractors (collectively, “FE Group”) consequential or indirect loss of any kind or nature arising from or in
                                  connection with this Agreement, including but not limited to loss of profit, use or goodwill, howsoever such may arise, whether in contract, tort, strict liability or otherwise.
                              </p>
                          </li>
                          <li data-list-text="10.2.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                  Except in case of breach of the obligations under Article 6, Confidentiality or in case of wilful misconduct or other similar circumstance for which a party may not lawfully limit its liability under this
                                  Agreement’s applicable law, the maximum cumulative liability of CAUSSA arising from or in connection with this Agreement, whether in contract or in tort, shall be limited to the lesser of (i) a sum equal to
                                  five times the remuneration paid to CAUSSA under this Agreement.
                              </p>
                          </li>
                          <li data-list-text="10.3.">
                              <p style="padding-left: 49pt; text-indent: -22pt; text-align: justify;">The FE shall indemnify and hold harmless CAUSSA from:</p>
                              <ol id="l20">
                                  <li data-list-text="10.3.1.">
                                      <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                                          Any liabilities, losses, damages, costs (including legal costs), claims and expenses incurred as a consequence of a failure of the FE to fulfil its obligations regarding the provision of accurate and
                                          timely information, material or data and access to sites, as well as a consequence of the use of the certificate in breach of the applicable requirements.
                                      </p>
                                  </li>
                                  <li data-list-text="10.3.2.">
                                      <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">Any claims from other companies in FE Group, whether in contract or in tort, arising from or in connection with this Agreement.</p>
                                  </li>
                              </ol>
                          </li>
                      </ol>
                  </ol>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="11.">
                  <h1 style="padding-left: 42pt; text-indent: -15pt; line-height: 11pt; text-align: justify;">Force majeure</h1>
                  <p style="padding-left: 27pt; text-indent: 0pt; text-align: justify;">
                      11.1. Delay in or failure of performance of either party hereto shall not constitute a default hereunder or give rise to any claim for damage if and to the extent such delay or failure is caused by any event beyond the
                      control of the party affected which the party had no reasonable way of preventing or grounds to anticipate, including but not limited to an act of war, natural disaster, fire, explosion, labour dispute or any
                      international sanctions or restrictions on trade. The affected party shall immediately notify the other party in writing of the causes and expected duration of any such occurrence.
                  </p>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="12.">
                  <h1 style="padding-left: 42pt; text-indent: -15pt; line-height: 11pt; text-align: left;">Law and Jurisdiction</h1>
                  <ol id="l21">
                      <ol id="l22">
                          <li data-list-text="12.1."><p style="padding-left: 49pt; text-indent: -22pt; line-height: 11pt; text-align: left;">This Agreement shall be governed and construed in accordance with the laws of India</p></li>
                          <li data-list-text="12.2.">
                              <p style="padding-left: 27pt; text-indent: 0pt; text-align: left;">
                                  Any dispute arising in relation to or as a consequence of this Agreement, which cannot be settled amicably through negotiations between the parties, shall be subject to the exclusive jurisdiction of the
                                  courts of Chennai.
                              </p>
                          </li>
                      </ol>
                  </ol>
                  <p style="text-indent: 0pt; text-align: left;"><br /></p>
              </li>
              <li data-list-text="13.">
                  <h1 style="padding-left: 42pt; text-indent: -15pt; text-align: justify;">Special Terms: <span class="p">NA</span></h1>
              </li>
          </ol>
          <p style="text-indent: 0pt; text-align: left;"><br /></p>
          <table style="border-collapse: collapse; margin-left: 11.914pt;" cellspacing="0">
              <tr style="height: 22pt;">
                  <td
                      style="
                          width: 253pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      colspan="4"
                  >
                      <p class="s2" style="padding-left: 22pt; text-indent: 0pt; text-align: left;">On Behalf of CAUSSA TEC SOLUTIONS PVT LTD</p>
                  </td>
                  <td
                      style="
                          width: 264pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      colspan="4"
                  >
                      <p class="s2" style="padding-left: 19pt; text-indent: 0pt; text-align: center;">On Behalf of FBO</p>
                  </td>
              </tr>
              <tr style="height: 35pt;">
                  <td
                      style="
                          width: 72pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p style="text-indent: 0pt; text-align: left;"><br />Signature</p>
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;"></p>
                  </td>
                  <td
                      style="
                          width: 181pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      colspan="3"
                  >
                      <p style="text-indent: 0pt; text-align: left;"><br /></p>
                  </td>
                  <td
                      style="
                          width: 66pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p style="text-indent: 0pt; text-align: left;"><br /></p>
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Signature</p>
                  </td>
                  <td
                      style="
                          width: 198pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      colspan="3"
                  >
                      <img 
                            width="131"
                            height="128"
                            src="${parsedFormDataAgreement && parsedFormDataAgreement.img}" 
                        />
                  </td>
              </tr>
              <tr style="height: 32pt;">
                  <td
                      style="
                          width: 72pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Name</p>
                  </td>
                  <td
                      style="
                          width: 181pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      colspan="3"
                  >
                      <p style="text-indent: 0pt; text-align: left;"></p>
                  </td>
                  <td
                      style="
                          width: 66pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Name</p>
                  </td>
                  <td
                      style="
                          width: 198pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      colspan="3"
                  >
                      <p style="text-indent: 0pt; text-align: left;">${GetSpecificUser && GetSpecificUser.contactPerson}</p>
                  </td>
              </tr>
              <tr style="height: 32pt;">
                  <td
                      style="
                          width: 72pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Designation</p>
                  </td>
                  <td
                      style="
                          width: 181pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      colspan="3"
                  >
                      <p style="text-indent: 0pt; text-align: left;"></p>
                  </td>
                  <td
                      style="
                          width: 66pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Designation</p>
                  </td>
                  <td
                      style="
                          width: 198pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                      colspan="3"
                  >
                      <p style="text-indent: 0pt; text-align: left;"></p>
                  </td>
              </tr>
              <tr style="height: 32pt;">
                  <td
                      style="
                          width: 72pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Place</p>
                  </td>
                  <td
                      style="
                          width: 70pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p style="text-indent: 0pt; text-align: left;"></p>
                  </td>
                  <td
                      style="
                          width: 35pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Date</p>
                  </td>
                  <td
                      style="
                          width: 76pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p style="text-indent: 0pt; text-align: left;">${formattedToday}</p>
                  </td>
                  <td
                      style="
                          width: 66pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Place</p>
                  </td>
                  <td
                      style="
                          width: 78pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p style="text-indent: 0pt; text-align: left;">${GetSpecificUser && GetSpecificUser.address}</p>
                  </td>
                  <td
                      style="
                          width: 35pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p class="s2" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Date</p>
                  </td>
                  <td
                      style="
                          width: 85pt;
                          border-top-style: solid;
                          border-top-width: 1pt;
                          border-left-style: solid;
                          border-left-width: 1pt;
                          border-bottom-style: solid;
                          border-bottom-width: 1pt;
                          border-right-style: solid;
                          border-right-width: 1pt;
                      "
                  >
                      <p style="text-indent: 0pt; text-align: left;">${formattedToday}</p>
                  </td>
              </tr>
          </table>
          <p style="padding-top: 11pt; text-indent: 0pt; text-align: left;"><br /></p>
          <p style="text-indent: 0pt; text-align: center;">******************************End of the Document*********************************</p>
      </body>
  </html>
  `;
};
export default HRA_Agreement;
